"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var operators_1 = require("rxjs/operators");
var value_binding_settings_component_1 = require("./settings/value-binding-settings.component");
var custom_data_1 = require("../../shared/model/custom-data");
var custom_calculation_service_1 = require("../../shared/services/api/custom-calculation.service");
var Subject_1 = require("rxjs/Subject");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var ValueBindingComponent = /** @class */ (function () {
    function ValueBindingComponent(customCalculationService) {
        this.customCalculationService = customCalculationService;
        this._destroy$ = new Subject_1.Subject();
        this._result = '';
    }
    Object.defineProperty(ValueBindingComponent.prototype, "hint", {
        get: function () {
            return this._hint;
        },
        set: function (value) {
            this._hint = idm_dynamic_forms_controls_1.stringToMultilingual(value);
        },
        enumerable: true,
        configurable: true
    });
    ValueBindingComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (this.entity && this.selectedCustomData) {
            this._result = '';
            this.customCalculationService.calculate(this.selectedCustomData['_key'], this.category, this.entity.getInstanceId(), this.entity, this.contextCategory, this.contextEntity.getInstanceId(), this.contextEntity)
                .pipe(operators_1.takeUntil(this._destroy$))
                .subscribe(function (res) {
                if (res) {
                    _this._result += res;
                }
            });
        }
    };
    Object.defineProperty(ValueBindingComponent.prototype, "result", {
        get: function () {
            return this._result;
        },
        enumerable: true,
        configurable: true
    });
    ValueBindingComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], ValueBindingComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], ValueBindingComponent.prototype, "contextEntity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ValueBindingComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ValueBindingComponent.prototype, "contextCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ValueBindingComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ValueBindingComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", custom_data_1.CustomData)
    ], ValueBindingComponent.prototype, "selectedCustomData", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant0", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant1", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant2", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant3", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant4", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant5", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant6", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant7", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant8", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingComponent.prototype, "participant9", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ValueBindingComponent.prototype, "hint", null);
    ValueBindingComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-value-binding',
            styles: [require('./value-binding.component.scss')],
            template: require('./value-binding.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 2,
            name: 'Value Binding',
            groups: [{ 'identity': 'zw', 'name': 'eJustice Controls' }],
            settings: {
                main: value_binding_settings_component_1.ValueBindingSettingsComponent,
            },
            template: "<ejustice-value-binding\n                    [entity]=\"entity\"\n                    [contextEntity]=\"contextEntity\"\n                    [category]=\"category\"\n                    [contextCategory]=\"contextCategory\"\n                    [isReadonly]=\"%{isReadonly}\"\n                    [currentLanguageId]=\"currentLanguageId\"\n                    [hint]=\"%{hint}\"\n                    [selectedCustomData]=\"%{selectedCustomData}\"\n                    [participant0]=\"%{participant0} && contextEntity ? contextEntity.getProperty(%{participant0}).value : null\"\n                    [participant1]=\"%{participant1} && contextEntity ? contextEntity.getProperty(%{participant1}).value : null\"\n                    [participant2]=\"%{participant2} && contextEntity ? contextEntity.getProperty(%{participant2}).value : null\"\n                    [participant3]=\"%{participant3} && contextEntity ? contextEntity.getProperty(%{participant3}).value : null\"\n                    [participant4]=\"%{participant4} && contextEntity ? contextEntity.getProperty(%{participant4}).value : null\"\n                    [participant5]=\"%{participant5} && contextEntity ? contextEntity.getProperty(%{participant5}).value : null\"\n                    [participant6]=\"%{participant6} && contextEntity ? contextEntity.getProperty(%{participant6}).value : null\"\n                    [participant7]=\"%{participant7} && contextEntity ? contextEntity.getProperty(%{participant7}).value : null\"\n                    [participant8]=\"%{participant8} && contextEntity ? contextEntity.getProperty(%{participant8}).value : null\"\n                    [participant9]=\"%{participant9} && contextEntity ? contextEntity.getProperty(%{participant9}).value : null\"\n                    >\n                </ejustice-value-binding>"
        }),
        __metadata("design:paramtypes", [custom_calculation_service_1.CustomCalculationService])
    ], ValueBindingComponent);
    return ValueBindingComponent;
}());
exports.ValueBindingComponent = ValueBindingComponent;
//# sourceMappingURL=value-binding.component.js.map